const load_posts = {
    
    loading: false,
    page: 1,
    ajax_url: '/wp-json/wp/v2/posts',
    num_posts: 4,
    post_offset: 0,
    posts_container: document.getElementById('ajax-posts'),
    active_cats: [],
    filter_data: {},

    init: () => {
        load_posts.bindEvents();
        load_posts.loadNext();
    },

    getPosts: async function (filter_data = {}) {
        let query_str = load_posts.ajax_url + '?per_page=' + load_posts.num_posts + '&offset=' + load_posts.post_offset
        filter_data.category_in ? query_str += '&categories=' + filter_data.category_in : null ;
        console.log(query_str)
        const response = await fetch(query_str, {
            method: "GET",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            redirect: "follow"
        });
        return await response.json();
    },


    filterCat: () => {
        load_posts.page = 1
        load_posts.post_offset = 0

        let cat_str = load_posts.active_cats.join(",")
        load_posts.filter_data = {}
        load_posts.filter_data = {
            category_in: cat_str
        }
        console.log('filter ya')
        //console.log(cat_str)

        load_posts.getPosts(load_posts.filter_data)
        .then(posts => {
            console.log(posts)            
            load_posts.posts_container.innerHTML = '';
            load_posts.showPosts(posts)
            load_posts.post_offset = load_posts.post_offset + posts.length 
        });
    },

    tagList : (all_tags) => {
        
        let tags = ``

        if(all_tags){
            all_tags.forEach(tag => {
                //console.log(tag)
                tags += `<a href="/tag/${tag.slug}" class="post-tag">${tag.name}</a>`
            })
        }

        return tags
    },

    loadNext : () => {

        //let filter_data = '&post_offset=' +load_posts.post_offset + '&action=ajax_next_posts';
        
        load_posts.getPosts(load_posts.filter_data)
            .then(posts => {
                load_posts.post_offset = load_posts.post_offset + load_posts.num_posts
                load_posts.showPosts(posts)
            });
    },

    showPosts: (posts) => {

        posts.forEach(post => {
            //console.log(post)
            let has_video = '';
            if(post.acf){
                if(post.acf.has_video == true) has_video = 'has-video'
            }

            let post_markup = `
            <article id="post-${post.id}" class="post-card">
                <a href="${post.link}">
                    <strong>${post.title.rendered}</strong>
                    <div class="post--image" style="background-image: url('${post.featured_image}');"></div>
                </a>
                
                <div class="post-content">
                    ${post.excerpt.rendered}
                    
                    <div class="tag-list">
                        ${load_posts.tagList(post.all_tags)}
                    </div>
            
                </div><!-- .entry-content -->
            </article><!-- #post-${post.id} -->      
            `
            load_posts.posts_container.innerHTML += post_markup
        })

        load_posts.loading = false

    },

    bindEvents: () => {
        document.getElementById('load-more').addEventListener('click', e => {
            if(!load_posts.loading) load_posts.loadNext()
            load_posts.loading = true;
        })

        let cats = document.querySelectorAll('.cat')
        cats.forEach(cat => {
            cat.addEventListener('click', e => {
                let term = cat.getAttribute('category');

                if(cat.classList.contains('active')){
                    cat.classList.remove('active')
                    var index = load_posts.active_cats.indexOf(term);
                    if (index > -1) {
                        load_posts.active_cats.splice(index, 1);
                    }   
                } else {
                    cat.classList.add('active')
                    load_posts.active_cats.push(term)
                }

                load_posts.filterCat()
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', function(e){
    if(load_posts.posts_container) load_posts.init();
    console.log('posts')
})